import ReactJson from 'react-json-view'

import type { RenderProps } from '~/modules/ppp/components/renderers/types'
import { filterNullsDeeply } from '~/modules/ppp/helpers'

type Props = RenderProps & {
  filterNulls?: boolean
}

export const JsonRenderer = ({ value: jsonAsString, filterNulls = false }: Props) => {
  const object = JSON.parse(jsonAsString)
  const json = filterNulls ? filterNullsDeeply(object) : object
  return (
    <ReactJson
      src={json}
      name={false}
      theme="summerfruit:inverted"
      enableClipboard={false} // we have our own clipboardCopy routine
      displayDataTypes={false}
      displayObjectSize
      iconStyle="circle"
    />
  )
}
